import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import './InvoiceForm.css';

const InvoiceForm = () => {
  const [customerInfo, setCustomerInfo] = useState({
    name: '', address1: '', address2: '', pin: '', mobile1: '', mobile2: '', gstin: '', email: ''
  });

  const [invoiceMeta, setInvoiceMeta] = useState({
    invoiceNo: '', from: '', to: '', invoiceDate: '', dueDate: ''
  });

  const [items, setItems] = useState([
    { date: '', awbNo: '', destination: '', weight: '', pkgs: '', docType: '', mode: '', rate: '', amount: '' }
  ]);

  const [gstCharges, setGstCharges] = useState({
    fuel: '', cgst: '', sgst: '', igst: '', totalAmount: ''
  });

  const [amountInWords, setAmountInWords] = useState('');

  const handleCustomerChange = e => {
    setCustomerInfo({ ...customerInfo, [e.target.name]: e.target.value });
  };

  const handleMetaChange = e => {
    setInvoiceMeta({ ...invoiceMeta, [e.target.name]: e.target.value });
  };

  const handleItemChange = (index, e) => {
    const newItems = [...items];
    newItems[index][e.target.name] = e.target.value;
    setItems(newItems);
  };

  const addItem = () => {
    setItems([...items, { date: '', awbNo: '', destination: '', weight: '', pkgs: '', docType: '', mode: '', rate: '', amount: '' }]);
  };

  const handleGstChange = e => {
    setGstCharges({ ...gstCharges, [e.target.name]: e.target.value });
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(14);
    doc.text('Shri Sai Logistics Invoice', 14, 10);

    doc.setFontSize(10);
    doc.text(`Invoice No: ${invoiceMeta.invoiceNo}`, 14, 20);
    doc.text(`Invoice Date: ${invoiceMeta.invoiceDate}`, 100, 20);

    doc.text(`Customer Name: ${customerInfo.name}`, 14, 30);
    doc.text(`Address: ${customerInfo.address1}, ${customerInfo.address2}`, 14, 36);
    doc.text(`Mobile: ${customerInfo.mobile1}, ${customerInfo.mobile2}`, 14, 42);
    doc.text(`Email: ${customerInfo.email}`, 14, 48);

    doc.autoTable({
      startY: 55,
      head: [["Date", "AWB No", "Destination", "Weight", "Pkgs", "DocType", "Mode", "Rate", "Amount"]],
      body: items.map(item => [
        item.date, item.awbNo, item.destination, item.weight, item.pkgs, item.docType, item.mode, item.rate, item.amount
      ])
    });

    let finalY = doc.lastAutoTable.finalY + 10;
    doc.text('GST & Charges:', 14, finalY);
    doc.text(`Fuel: ${gstCharges.fuel}`, 14, finalY + 6);
    doc.text(`CGST: ${gstCharges.cgst}`, 14, finalY + 12);
    doc.text(`SGST: ${gstCharges.sgst}`, 14, finalY + 18);
    doc.text(`IGST: ${gstCharges.igst}`, 14, finalY + 24);
    doc.text(`Total: ${gstCharges.totalAmount}`, 14, finalY + 30);

    doc.text(`Amount in Words: ${amountInWords}`, 14, finalY + 40);

    doc.save(`Invoice_${invoiceMeta.invoiceNo || 'ShriSai'}.pdf`);
  };

  return (
    <div className="invoice-container">
      <h2>Shri Sai Logistics Invoice</h2>

      <div className="section">
        <h4>Customer Information</h4>
        {Object.keys(customerInfo).map(key => (
          <input
            key={key}
            name={key}
            placeholder={key.replace(/\B([A-Z])/g, ' $1')}
            value={customerInfo[key]}
            onChange={handleCustomerChange}
          />
        ))}
      </div>

      <div className="section">
        <h4>Invoice Details</h4>
        {Object.keys(invoiceMeta).map(key => (
          <input
            key={key}
            name={key}
            placeholder={key.replace(/\B([A-Z])/g, ' $1')}
            value={invoiceMeta[key]}
            onChange={handleMetaChange}
          />
        ))}
      </div>

      <div className="section">
        <h4>Invoice Items</h4>
        <table>
          <thead>
            <tr>
              <th>Date</th><th>AWB No</th><th>Destination</th><th>Weight</th><th>Pkgs</th><th>DocType</th><th>Mode</th><th>Rate</th><th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                {Object.keys(item).map(field => (
                  <td key={field}>
                    <input
                      type="text"
                      name={field}
                      value={item[field]}
                      onChange={e => handleItemChange(index, e)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <button onClick={addItem}>Add Item</button>
      </div>

      <div className="section">
        <h4>GST & Charges</h4>
        {Object.keys(gstCharges).map(key => (
          <input
            key={key}
            name={key}
            placeholder={key.toUpperCase()}
            value={gstCharges[key]}
            onChange={handleGstChange}
          />
        ))}
      </div>

      <div className="section">
        <h4>Amount in Words</h4>
        <input
          type="text"
          placeholder="Amount in Words"
          value={amountInWords}
          onChange={e => setAmountInWords(e.target.value)}
        />
      </div>

      <div className="section">
        <h4>Terms & Conditions</h4>
        <ol>
          <li>Subject to Mumbai Jurisdiction only.</li>
          <li>All bills to be paid within one week of bill date.</li>
          <li>Cheques in favor of "SHRI SAI LOGISTICS".</li>
          <li>Green Dart not liable for delays shown in Consignment Note.</li>
          <li>Valid when duly signed and stamped.</li>
        </ol>
      </div>

      <button onClick={generatePDF} className="download-btn">Download PDF</button>
    </div>
  );
};

export default InvoiceForm;
